import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { brandNeutralColors, colors } from 'ui_system/compass/utils/theme';
import { ReactModal } from '../../ui_system/modals';
import { Theme } from '../../ui_system/theme';
import { ArrowIcon } from '../ui/icons';
import { WaiverModalContent } from './WaiverModalContent';

export const CenteredColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Container = styled.div`
  width: 630px;

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    width: 328px;
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 500;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    text-align: center;
  }
`;

export const Subtitle = styled.p`
  font-size: 16px;
  margin-top: 8px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    text-align: center;
  }
`;

type SeparatorLineProps = {
  hideOnMobile?: boolean;
};

type CheckboxLinkProps = {
  linkColor?: string;
};

export const SeparatorLine = styled.div<SeparatorLineProps>`
  width: 100%;
  border-top: 1px solid ${Theme.colors.dividerInactionableFieldColor};
  margin: 32px 0;

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    ${(props) => props?.hideOnMobile && 'display: none;'}
  }
`;

export const Form = styled.form`
  margin-bottom: 60px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    margin-top: 40px;
  }
`;

export const Label = styled.label`
  font-size: 16px;
  font-weight: 600;
`;

// TODO can move this component to shared ?
// styles adapted from Input component stylesheet
// views/ui/form_elements/input
// frontend/components/views/ui/form_elements/input/index.scss
export const Input = styled.input`
  color: ${brandNeutralColors.text.primary};
  border: 1px solid ${Theme.colors.borderActionableFieldColor};
  width: 100%;
  height: 47px;
  line-height: normal;
  border-radius: 0px;
  padding: 0 10px;
  margin-left: 0;
  font-size: 14px;
  font-family: inherit;
  font-weight: 400;
  margin-top: 8px;

  &::placeholder {
    color: ${Theme.colors.guideTextColor};
    font-family: inherit;
    font-weight: 400;
  }
`;

type StyleProps = {
  isError?: boolean;
  paddingRequired?: boolean;
};

export const EmailField = styled.div<StyleProps>`
  ${Input} {
    outline: none;
    border: 1px solid
      ${(props) =>
        props.isError
          ? Theme.colors.errorRedColor
          : Theme.colors.borderActionableFieldColor};
    border-left: ${(props) =>
      props.isError && `5px solid ${Theme.colors.errorRedColor}`};
    padding-left: ${(props) => props.isError && '7px'};
  }
`;

export const InputFieldErrorMessage = styled.span`
  display: block;
  background: #d82f2e;
  color: white;
  font-size: 14px;
  padding: 10px;
  width: 100%;
`;

export const ErrorMessage = styled.div`
  color: red;
  margin-top: 5px;
  font-size: 14px;
  font-weight: 400;
`;

type SubmitButtonProps = {
  backgroundColor: string;
};

export const SubmitButton = styled.button<SubmitButtonProps>`
  color: white;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  border-radius: 4px;
  padding: 12px 34px;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : Theme.colors.blue};
  &:disabled {
    opacity: 0.5;
  }
`;

export const NavigationWrapper = styled(Link)`
  display: flex;
  margin: 32px 0 30px 0;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    margin: 24px 0 19px 0;
  }
`;

export const LeftArrow = styled(ArrowIcon)`
  transform: rotate(90deg);
  z-index: -1;
  fill: ${(props) => props.highlightcolor};
`;

export const LinkBack = styled.div<SubmitButtonProps>`
  font-size: 14px;
  line-height: 18px;
  margin-left: 8px;
  color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : Theme.colors.blue};
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: 13px;
    line-height: 17px;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
`;

export const SuggestionContainer = styled.div`
  margin-top: 16px;
  display: flex;
  padding: 10px;
  background-color: ${brandNeutralColors.background.light};
  color: ${brandNeutralColors.text.primary};
  font-size: 16px;
  b {
    font-weight: 500;
  }
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    width: 100%;
    flex-direction: column;
  }
`;

type InviteLinkProps = {
  linkColor: string;
};

export const InviteLink = styled.a<InviteLinkProps>`
  text-decoration: underline;
  color: ${(props) => (props.linkColor ? props.linkColor : colors.primary)};
  font-weight: 400;
  font-size: 16px;

  &:hover {
    color: ${(props) => (props.linkColor ? props.linkColor : colors.primary)};
    text-decoration: underline;
  }
`;

export const CheckoutWaiverContainer = styled.div<StyleProps>`
  padding: ${(props) => props.paddingRequired && '30px 0px 30px 0px'};
  @media only screen and (max-width: 767px) {
    padding-bottom: 10px;
  }
  & > .checkbox-border {
    display: flex;
    align-items: center;
  }
`;

export const WaiverCheckbox = styled.div<StyleProps>`
  outline: none;
  border: 1px solid
    ${(props) => (props.isError ? Theme.colors.errorRedColor : 'none')};
  border-left: 5px solid
    ${(props) => (props.isError ? Theme.colors.errorRedColor : 'none')};
`;

export const StyledWaiverModalView = styled(ReactModal(WaiverModalContent))`
  padding: 20px !important;
  @media (max-width: ${Theme.mobile.phoneWidth}px) {
    min-height: 0;
    width: 328px !important;
  }
`;

export const WaiverLink = styled.a<CheckboxLinkProps>`
  margin-left: 5px;
  text-decoration: underline;
  color: ${(props) => (props.linkColor ? props.linkColor : Theme.colors.blue)};
  font-size: 14px;
  font-weight: 400;
  :hover {
    color: ${(props) =>
      props.linkColor ? props.linkColor : Theme.colors.blue};
    text-decoration: underline;
  }
`;
